(function() { window.GUID_692f0b39_1976_40a7_b59f_de97fe5351c2 = { getGuid: function() { return "692f0b39-1976-40a7-b59f-de97fe5351c2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DatesRangeButtons extends Controls.ControlBase {
            get ControlId() {
                return this.param.controlId;
            }
            get $Control() {
                return this.param.container;
            }
            OnControlInstantiation(params) {
                this.param = params[0];
                this.SetMinMaxDates(this.param.minValue, this.param.maxValue);
            }
            SetMinMaxDates(minDate, maxDate) {
                if (minDate instanceof Date)
                    this.startDate = this.getMoment(minDate);
                else
                    this.startDate = minDate;
                if (maxDate instanceof Date)
                    this.endDate = this.getMoment(maxDate);
                else
                    this.endDate = maxDate;
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() {
                for (var i = 0; i < this.param.buttons.length; i++) {
                    let btn = this.param.buttons[i];
                    Controls.Button.Events.Clicked({
                        selector: btn.button,
                        callback: (control, e) => {
                            var newRange = this.getNewRange(btn);
                            this.Trigger(that.EventNames.RangeSelected, {
                                jqueryEventObject: e.jqueryEventObject,
                                data: {
                                    clickedButton: btn,
                                    maxValue: newRange.maxValue,
                                    minValue: newRange.minValue
                                }
                            });
                        }
                    });
                }
            }
            constructor(param) {
                super(param);
                this.getDate = CS.Helper.MomentJs.ConvertMomentToJsDate;
                this.manipulateDate = CS.Helper.MomentJs.manipulateDate;
            }
            //Utc is used as the defaut to be the same as the graph, in case we future use moment(because its awsome :) );
            getMoment(date) {
                return moment.utc(date);
            }
            getNewRange(button) {
                if (button.dontUseFromEnd) {
                    //use from start
                    let minDate = this.getDate(this.startDate);
                    let maxDateMoment = this.manipulateDate(this.startDate, button.timeSpan, "add");
                    if (maxDateMoment.isAfter(this.endDate))
                        maxDateMoment = this.endDate;
                    let maxDate = this.getDate(maxDateMoment);
                    return { minValue: minDate, maxValue: maxDate };
                }
                else {
                    //use from end
                    let maxDate = this.getDate(this.endDate);
                    let minDateMoment = this.manipulateDate(this.endDate, button.timeSpan, "subtract");
                    if (minDateMoment.isBefore(this.startDate))
                        minDateMoment = this.startDate;
                    let minDate = this.getDate(minDateMoment);
                    return { minValue: minDate, maxValue: maxDate };
                }
            }
        }
        Controls.DatesRangeButtons = DatesRangeButtons;
        (function (DatesRangeButtons) {
            class Events {
                static RangeSelected(param) {
                    Controls.RegisterEvent(that, EventNames.RangeSelected, param);
                }
            }
            DatesRangeButtons.Events = Events;
            class EventNames {
            }
            EventNames.RangeSelected = "daterange-button-rangeselected";
            DatesRangeButtons.EventNames = EventNames;
        })(DatesRangeButtons = Controls.DatesRangeButtons || (Controls.DatesRangeButtons = {}));
        var that = DatesRangeButtons;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=DatesRangeButtons.js.map
